import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ManuallyApprovedPatch } from '../types';

export abstract class MaintenanceWindowManuallyApprovedPatchesSelectorBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getManuallyApprovedPatchesForCompany(companyId: string): Promise<ManuallyApprovedPatch[]>;
}
